import type { NavigateFunction } from 'react-router-dom';
export class history {
  static push: NavigateFunction;
}
